import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusKey } from '../../utils/statistics';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';

export const useStatusLabels = (): Record<StatusKey, string> => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      confirmed: t(COMMON_TRANSLATE_KEYS.STATS_CONFIRMED),
      pending: t(COMMON_TRANSLATE_KEYS.STATS_PENDING),
      unanswered: t(COMMON_TRANSLATE_KEYS.STATS_UNANSWERED),
      declined: t(COMMON_TRANSLATE_KEYS.STATS_DECLINED),
    }),
    [t]
  );
};
